import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    text-align: center;
    font-size: 12px;
    transition: all 0.1s ease-in;
    cursor: pointer;

    .stroke-solid {
      stroke: ${theme.darkTheme.colors.white};
      stroke-width: 1.8px;
      fill: transparent;
      transition: fill 1s ease-out;
    }

    .icon {
      fill: ${theme.darkTheme.colors.white};
      transform: scale(0.9);
      transform-origin: 50% 50%;
    }

    // Hover
    #share:hover {
      .stroke-solid {
        stroke: ${theme.darkTheme.colors.green};
        opacity: 1;
      }
      .icon {
        fill: ${theme.darkTheme.colors.green};
      }
    }
  `}
`;
